module.exports = __webpack_public_path__ + "61e6b2efccd79f940f33fe592af175d6.png";